import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me')
        .then(r => setUser(r.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  function logout() {
    localStorage.removeItem('token');
    setUser(null);
  }

  // Нормалізуємо роль до нижнього регістру
  const normalizeRole = (role) => role?.toLowerCase();

  const isSuperAdmin = normalizeRole(user?.role) === 'super_admin';

  const isStoreAdmin = (storeId) =>
    isSuperAdmin ||
    user?.store_memberships?.some(
      m => m.store_id === storeId && normalizeRole(m.role) === 'store_admin'
    );

  const hasAccessToStore = (storeId) =>
    isSuperAdmin ||
    user?.store_memberships?.some(m => m.store_id === storeId);

  const myRoleInStore = (storeId) => {
    if (isSuperAdmin) return 'super_admin';
    return normalizeRole(user?.store_memberships?.find(m => m.store_id === storeId)?.role);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout, loading, isSuperAdmin, isStoreAdmin, hasAccessToStore, myRoleInStore }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
